<template>
  <div>
    <v-form ref="form"
            v-model="isFormValid"
            lazy-validation>
      <template v-if="isCompanyLoaded">
        <v-row dense>
          <v-col cols="12"
                 sm="6">
            <v-text-field v-model="clonedCompanyDetails.displayName"
                          outlined
                          dense
                          required
                          :label="translations.companyName"
                          :rules="companyNameRules"
                          @input="disabledAction = false">
            </v-text-field>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <v-select v-model="clonedCompanyDetails.partnerId"
                      item-text="displayName"
                      item-value="id"
                      outlined
                      dense
                      offset-y
                      required
                      :items="partners"
                      :label="translations.partners"
                      :rules="partnerSelectRules"
                      :disabled="detailsModalConfig.updateCompany">
            </v-select>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <FilterMultiselect :items="formattedCurrencies"
                               :text="'name'"
                               :value="'name'"
                               :label="translations.currencies"
                               :name="'currencies'"
                               :hideDetails="false"
                               :rules="currenciesRules"
                               :required="true"
                               :querySelected="clonedCompanyDetails.currencies"
                               @updateSelectAll="updateCurrencies" />
          </v-col>
          <v-col cols="12"
                 sm="6">
            <FilterMultiselect :items="bootstrap.markets"
                               :label="translations.markets"
                               :hideDetails="false"
                               :querySelected="clonedCompanyDetails.settings.markets"
                               @updateSelectAll="updateMarkets" />
          </v-col>
          <v-col cols="12"
                 sm="6">
            <v-select v-model="clonedCompanyDetails.dc"
                      label="DC"
                      required
                      outlined
                      dense
                      :items="bootstrap.dataCenters"
                      :rules="dcRules"
                      :disabled="detailsModalConfig.updateCompany"
                      @input="disabledAction = false">
            </v-select>
          </v-col>
          <v-col v-if="isSevenPartner"
                 cols="12"
                 sm="6">
            <v-select v-model="clonedCompanyDetails.meta.sevenWalletDC"
                      required
                      outlined
                      dense
                      :items="bootstrap.sevenWalletDcs"
                      :label="translations.walletDc"
                      :rules="sevenWalletDcRules"
                      @input="disabledAction = false">
            </v-select>
          </v-col>
          <v-col v-if="isSevenPartner"
                 cols="12"
                 sm="6">
            <v-text-field v-model="clonedCompanyDetails.meta.sevenCompanyId"
                          outlined
                          dense
                          required
                          :label="translations.sevenCompanyId"
                          :rules="sevenCompanyIdRules"
                          @input="disabledAction = false">
            </v-text-field>
          </v-col>
          <v-col v-if="isIsoftbetPartner"
                 cols="12"
                 sm="6">
            <v-text-field v-model="clonedCompanyDetails.meta.isoftbetLicenseeId"
                          type="number"
                          outlined
                          dense
                          required
                          :rules="isoftbetLicenseeIdRules"
                          :label="translations.licenseeId"
                          @input="disabledAction = false">
            </v-text-field>
          </v-col>
          <v-col v-if="isIsoftbetPartner"
                 cols="12"
                 sm="6">
            <v-text-field v-model="clonedCompanyDetails.meta.isoftbetWalletUrl"
                          outlined
                          dense
                          required
                          :rules="isoftbetWalletUrlRules"
                          :label="translations.walletUrl"
                          @input="disabledAction = false">
            </v-text-field>
          </v-col>
          <v-col v-if="isDualSoftPartner"
                 cols="12"
                 sm="6">
            <v-combobox v-model="clonedCompanyDetails.meta.dualsoftWalletCode"
                        append-icon=""
                        multiple
                        small-chips
                        deletable-chips
                        outlined
                        dense
                        required
                        :rules="dualsoftWalletCodeRules"
                        :hint="translations.dualSoftWalletCodeHint"
                        :label="translations.walletCode"
                        @input="disabledAction = false">
            </v-combobox>
          </v-col>
          <v-col v-if="isDualSoftPartner"
                 cols="12"
                 sm="6">
            <v-text-field v-model="clonedCompanyDetails.meta.dualsoftWalletUrl"
                          outlined
                          dense
                          required
                          :rules="dualsoftWalletUrlRules"
                          :label="translations.walletUrl"
                          @input="disabledAction = false">
            </v-text-field>
          </v-col>
          <v-col v-if="isSingularPartner"
                 cols="12"
                 sm="6">
            <v-text-field v-model="clonedCompanyDetails.meta.brand"
                          outlined
                          dense
                          required
                          :label="translations.brand"
                          :rules="singularBrandRules"
                          @input="disabledAction = false">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isDualSoftPartner">
          <v-card-subtitle class="px-0 font-italic text--text">
            <v-icon class="mr-3 text--text">mdi-information-outline</v-icon>
            {{ dualSoftCompanyInfoLabel }}
          </v-card-subtitle>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col>
            <v-switch v-model="clonedCompanyDetails.jackpotActive"
                      class="labeledSwitch label-left"
                      hide-details
                      :label="translations.jackpot"
                      @click="disabledAction = false">
            </v-switch>
          </v-col>
        </v-row>
        <v-row v-if="clonedCompanyDetails.jackpotActive">
          <v-col>
            <v-text-field v-model="clonedCompanyDetails.jackpotContribution"
                          outlined
                          dense
                          type="number"
                          :label="translations.jackpotContributionHeader"
                          :hint="translations.jackpotContributionTooltip"
                          :rules="jackpotContributionRules"
                          @input="disabledAction = false">
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field v-model="clonedCompanyDetails.jackpotProbability"
                          outlined
                          dense
                          type="number"
                          :label="translations.jackpotProbability"
                          :hint="translations.jackpotProbabilityTooltip"
                          :rules="jackpotRoundsRules"
                          @input="disabledAction = false">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="currenciesList.length">
          <v-col v-for="(currency, index) in currenciesList"
                 :key="index"
                 cols="12">
            <v-card outlined>
              <v-card-title class="py-2 px-3 text-subtitle-1">{{ currency }}</v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle class="px-3">
                <v-tooltip transition="slide-x-transition"
                           right
                           max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-html="translations.perLineLimits"></span>
                    <v-icon dark
                            small
                            color="disabled"
                            class="pl-2 mt-n1"
                            v-bind="attrs"
                            v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span v-html="translations.tenantPerLineLimitsTooltip"></span>
                </v-tooltip>
              </v-card-subtitle>
              <v-card-text class="px-3">
                <v-row>
                  <v-col cols="4">
                    <v-text-field :value="getCurrencyLimitValue(currency, 'minBetPerLineAmount')"
                                  outlined
                                  dense
                                  required
                                  :label="translations.minBetPerLine"
                                  :rules="currencyMinBetRules(currency, 'minBetPerLineAmount', 'maxBetPerLineAmount')"
                                  @input="handleCurrencyLimitChange($event, currency, 'minBetPerLineAmount')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field :value="getCurrencyLimitValue(currency, 'maxBetPerLineAmount')"
                                  outlined
                                  dense
                                  required
                                  :label="translations.maxBetPerLine"
                                  :rules="currencyMaxBetRules(currency, 'maxBetPerLineAmount', 'minBetPerLineAmount')"
                                  @input="handleCurrencyLimitChange($event, currency, 'maxBetPerLineAmount')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field :value="getCurrencyLimitValue(currency, 'maxWinPerLineAmount')"
                                  outlined
                                  dense
                                  required
                                  :label="translations.maxWinLimit"
                                  :rules="currencyMaxWinLimitRules(currency, 'maxWinPerLineAmount', 'maxBetPerLineAmount')"
                                  @input="handleCurrencyLimitChange($event, currency, 'maxWinPerLineAmount')">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-subtitle class="px-3">
                <v-tooltip transition="slide-x-transition"
                           right
                           max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-html="translations.totalLimits"></span>
                    <v-icon dark
                            small
                            color="disabled"
                            class="pl-2 mt-n1"
                            v-bind="attrs"
                            v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span v-html="translations.tenantTotalLimitsTooltip"></span>
                </v-tooltip>
              </v-card-subtitle>
              <v-card-text class="px-3">
                <v-row>
                  <v-col cols="4">
                    <v-text-field :value="getCurrencyLimitValue(currency, 'minBetAmount')"
                                  outlined
                                  dense
                                  required
                                  :label="translations.minBet"
                                  :rules="currencyMinBetRules(currency, 'minBetAmount', 'maxBetAmount')"
                                  @input="handleCurrencyLimitChange($event, currency, 'minBetAmount')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field :value="getCurrencyLimitValue(currency, 'maxBetAmount')"
                                  outlined
                                  dense
                                  required
                                  :label="translations.maxBet"
                                  :rules="currencyMaxBetRules(currency, 'maxBetAmount', 'minBetAmount')"
                                  @input="handleCurrencyLimitChange($event, currency, 'maxBetAmount')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field :value="getCurrencyLimitValue(currency, 'maxWinAmount')"
                                  outlined
                                  dense
                                  required
                                  :label="translations.maxWinLimit"
                                  :rules="currencyMaxWinLimitRules(currency, 'maxWinAmount', 'maxBetAmount')"
                                  @input="handleCurrencyLimitChange($event, currency, 'maxWinAmount')">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <transition name="slide"
                  appear>
        <v-card class="fotterCard"
                tile
                elevation="10"
                v-if="detailsModalToggler">
          <v-row class="px-8 py-3">
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn text
                     small
                     class="text-none"
                     width="120"
                     @click="cancelButton()">
                <LocalizedLabel>cancel</LocalizedLabel>
              </v-btn>
              <v-btn small
                     color="primary"
                     class="background--text text-none"
                     width="120"
                     :key="actionKey"
                     :disabled="disabledAction"
                     @click.once="actionButton()">
                <LocalizedLabel>save</LocalizedLabel>
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-card>
      </transition>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  cloneDeep,
  has,
  isEmpty,
  isEqual,
  map,
  merge,
  pickBy,
  set,
} from 'lodash';
import {
  arrayLength,
  isDecimal,
  isEntered,
  isLarger,
  isLargerOrEqual,
  isSmaller,
  mapCurrencyLimitsToGameTypes,
  mapGameTypesToCurrencyLimits,
  nameLength,
  noDecimal,
  roundAmountsInput,
} from '@/utility';
import FilterMultiselect from '@/components/FilterMultiselect';

export default {
  name: 'companyDetailsEdit',
  components: {
    FilterMultiselect,
  },
  data() {
    return {
      actionKey: 0,
      isFormValid: true,
      disabledAction: false,
      companyDetails: {},
      clonedCompanyDetails: { jackpotActive: true, meta: {}, settings: {} },
      currenciesList: [],
      currenciesLimits: {},
    };
  },
  methods: {
    ...mapActions([
      'createData',
      'getBootstrap',
      'loadData',
      'setSnackbarNotification',
      'toggleDetailsModal',
      'updateData',
    ]),
    actionButton() {
      if (this.$refs.form.validate()) {
        this[this.detailsModalConfig.action]();
      } else {
        this.setSnackbarNotification({
          label: this.translations.companyEditCurrencyErrorMessage,
          text: true,
          color: 'error',
        });
        this.actionKey += 1;
      }
    },
    cancelButton() {
      this.toggleDetailsModal(false);
      this.$refs.form.reset();
    },
    async createCompany() {
      this.formatJackpot();
      const payloadParameters = pickBy({
        active: true,
        displayName: this.clonedCompanyDetails.displayName,
        partnerId: this.clonedCompanyDetails.partnerId,
        currencies: this.clonedCompanyDetails.currencies,
        dc: this.clonedCompanyDetails.dc,
        settings: {
          gameTypes: mapCurrencyLimitsToGameTypes(this.currenciesLimits, this.currenciesList),
          jackpot: this.clonedCompanyDetails.settings.jackpot,
          markets: this.clonedCompanyDetails.settings.markets,
        },
      });

      if (this.clonedCompanyDetails?.meta?.sevenWalletDC) {
        set(payloadParameters, 'meta.sevenWalletDC', this.clonedCompanyDetails.meta.sevenWalletDC);
      }
      if (this.clonedCompanyDetails?.meta?.sevenCompanyId) {
        set(payloadParameters, 'meta.sevenCompanyId', this.clonedCompanyDetails.meta.sevenCompanyId);
      }
      if (this.clonedCompanyDetails?.meta?.isoftbetLicenseeId) {
        set(payloadParameters, 'meta.isoftbetLicenseeId', this.clonedCompanyDetails.meta.isoftbetLicenseeId);
      }
      if (this.clonedCompanyDetails?.meta?.isoftbetWalletUrl) {
        set(payloadParameters, 'meta.isoftbetWalletUrl', this.clonedCompanyDetails.meta.isoftbetWalletUrl);
      }
      if (this.clonedCompanyDetails?.meta?.dualsoftWalletCode) {
        set(payloadParameters, 'meta.dualsoftWalletCode', this.clonedCompanyDetails?.meta?.dualsoftWalletCode);
      }
      if (this.clonedCompanyDetails?.meta?.dualsoftWalletUrl) {
        set(payloadParameters, 'meta.dualsoftWalletUrl', this.clonedCompanyDetails?.meta?.dualsoftWalletUrl);
      }
      if (this.clonedCompanyDetails?.meta?.brand) {
        set(payloadParameters, 'meta.brand', this.clonedCompanyDetails?.meta?.brand);
      }

      const response = await this.createData({
        data: payloadParameters,
        path: 'tenants',
        notification: 'createCompanyLabel',
      });
      if (response) {
        this.reloadBootstrap();
      } else {
        this.actionKey += 1;
      }
    },
    async updateCompany() {
      this.formatJackpot();
      const payloadParameters = pickBy({
        displayName: this.clonedCompanyDetails.displayName,
        currencies: this.clonedCompanyDetails.currencies,
        settings: {
          gameTypes: mapCurrencyLimitsToGameTypes(this.currenciesLimits, this.currenciesList),
          jackpot: this.clonedCompanyDetails.settings.jackpot,
          markets: this.clonedCompanyDetails.settings.markets,
        },
      });

      if (this.clonedCompanyDetails?.meta?.sevenWalletDC) {
        set(payloadParameters, 'meta.sevenWalletDC', this.clonedCompanyDetails.meta.sevenWalletDC);
      }
      if (this.clonedCompanyDetails?.meta?.sevenCompanyId) {
        set(payloadParameters, 'meta.sevenCompanyId', this.clonedCompanyDetails.meta.sevenCompanyId);
      }
      if (this.clonedCompanyDetails?.meta?.isoftbetLicenseeId) {
        set(payloadParameters, 'meta.isoftbetLicenseeId', this.clonedCompanyDetails.meta.isoftbetLicenseeId);
      }
      if (this.clonedCompanyDetails?.meta?.isoftbetWalletUrl) {
        set(payloadParameters, 'meta.isoftbetWalletUrl', this.clonedCompanyDetails.meta.isoftbetWalletUrl);
      }
      if (this.clonedCompanyDetails?.meta?.dualsoftWalletCode) {
        set(payloadParameters, 'meta.dualsoftWalletCode', this.clonedCompanyDetails?.meta?.dualsoftWalletCode);
      }
      if (this.clonedCompanyDetails?.meta?.dualsoftWalletUrl) {
        set(payloadParameters, 'meta.dualsoftWalletUrl', this.clonedCompanyDetails?.meta?.dualsoftWalletUrl);
      }
      if (this.clonedCompanyDetails?.meta?.brand) {
        set(payloadParameters, 'meta.brand', this.clonedCompanyDetails?.meta?.brand);
      }

      const response = await this.updateData({
        data: payloadParameters,
        path: `tenants/${this.$route.query.companyId}`,
        notification: 'updateCompanyLabel',
      });
      if (response) {
        this.reloadBootstrap();
      } else {
        this.actionKey += 1;
      }
    },
    updateCurrencies(name, value) {
      this.currenciesList = value;
      this.clonedCompanyDetails.currencies = value;
      this.disabledAction = false;
    },
    updateMarkets(name, value) {
      this.clonedCompanyDetails.settings.markets = value;

      if (!isEqual(this.clonedCompanyDetails.settings.markets, this.companyDetails?.settings?.markets)) {
        this.disabledAction = false;
      }
    },
    formatJackpot() {
      const jackpot = pickBy({
        contribution:
          roundAmountsInput(this.clonedCompanyDetails.jackpotContribution),
        probabilityPct: this.getJackpotProbability(this.clonedCompanyDetails.jackpotProbability, 'isProbability'),
      });
      set(jackpot, 'active', this.clonedCompanyDetails.jackpotActive);
      set(this.clonedCompanyDetails.settings, 'jackpot', jackpot);
    },
    async prepareFormForEdit() {
      if (this.detailsModalConfig.updateCompany) {
        const response = await this.loadData({
          path: `tenants/${this.$route.query.companyId}`,
        });
        if (response) {
          this.companyDetails = cloneDeep(this.mappedDetails(response.data));
          this.disabledAction = true;
          merge(this.clonedCompanyDetails, cloneDeep(this.companyDetails));
          this.currenciesLimits = mapGameTypesToCurrencyLimits(
            this.clonedCompanyDetails.settings?.gameTypes,
          );
        }
      }
    },
    async reloadBootstrap() {
      await this.toggleDetailsModal(false);
      this.getBootstrap();
    },
    getJackpotStatus(value) {
      return has(value, 'active') ? value.active : true;
    },
    getJackpotProbability(value, isProbability) {
      if (isProbability) {
        return value ? 1 / value : null;
      }
      return value ? Math.ceil(1 / value).toFixed() : null;
    },
    mappedDetails(value) {
      if (value) {
        const list = map([value], (company) => ({
          ...company,
          displayName: company.displayName,
          partnerId: company.partnerId,
          externalId: company.externalId,
          currencies: company.currencies,
          jackpotActive: this.getJackpotStatus(company.settings.jackpot),
          jackpotContribution: company.settings.jackpot
            ? company.settings.jackpot.contribution : null,
          jackpotProbability: this.getJackpotProbability(company.settings.jackpot.probabilityPct),
        }));
        return list[0];
      }
      return [];
    },
    handleCurrencyLimitChange(value, currency, inputType) {
      if (!this.currenciesLimits[currency]) {
        this.$set(this.currenciesLimits, currency, {});
      }
      this.$set(this.currenciesLimits[currency], inputType, value);
      this.disabledAction = false;
    },
    getCurrencyLimitValue(currency, inputType) {
      return this.currenciesLimits[currency]?.[inputType];
    },
    currencyMinBetRules(currency, minKey, maxKey) {
      return [
        isEntered(this.getCurrencyLimitValue(currency, minKey),
          this.translations.amountErrorLabel),
        isDecimal(this.translations.decimalsAllowedErrorLabel),
        (amount) => {
          const maxBet = this.getCurrencyLimitValue(currency, maxKey);
          return !maxBet || isSmaller(maxBet, this.translations.settingsStakeErrorLabel)(amount);
        },
      ];
    },
    currencyMaxBetRules(currency, maxKey, minKey) {
      return [
        isEntered(this.getCurrencyLimitValue(currency, maxKey),
          this.translations.amountErrorLabel),
        isDecimal(this.translations.decimalsAllowedErrorLabel),
        (amount) => {
          const minBet = this.getCurrencyLimitValue(currency, minKey);
          return !minBet || isLarger(minBet, this.translations.settingsStakeErrorLabel)(amount);
        },
      ];
    },
    currencyMaxWinLimitRules(currency, maxWinKey, maxBetKey) {
      if (!this.getCurrencyLimitValue(currency, maxWinKey)) {
        return [true];
      }
      return [
        isLarger(0, this.translations.maxWinAmountErrorLabel),
        noDecimal(this.translations.noDecimalsAllowedErrorLabel),
        (amount) => {
          const maxBet = this.getCurrencyLimitValue(currency, maxBetKey);
          return !maxBet || isLargerOrEqual(maxBet * 10,
            this.translations.maxWinAtLeastTenTimesMaxBetErrorLabel)(amount);
        },
      ];
    },
  },
  computed: {
    ...mapGetters([
      'bootstrap',
      'detailsModalConfig',
      'detailsModalToggler',
      'partners',
      'selectedPartner',
      'translations',
    ]),
    isCompanyLoaded() {
      if (this.detailsModalConfig.createCompany) {
        return true;
      }
      return !isEmpty(this.companyDetails);
    },
    isSevenPartner() {
      const sevenPartner = this.partners.find((partner) => partner.displayName === 'Seven');

      return this.clonedCompanyDetails.partnerId === sevenPartner?.id;
    },
    isDualSoftPartner() {
      const dualSoftPartner = this.partners.find((partner) => partner.displayName === 'DualSoft');

      return this.clonedCompanyDetails.partnerId === dualSoftPartner?.id;
    },
    isIsoftbetPartner() {
      const isoftbetPartner = this.partners.find((partner) => partner.displayName === 'iSoftBet');

      return this.clonedCompanyDetails.partnerId === isoftbetPartner?.id;
    },
    isSingularPartner() {
      const singularPartner = this.partners.find((partner) => partner.displayName === 'Singular');

      return this.clonedCompanyDetails.partnerId === singularPartner?.id;
    },
    dualSoftCompanyInfoLabel() {
      return this.detailsModalConfig.createCompany
        ? this.translations.dualSoftCompanyCreateLabel
        : this.translations.dualSoftCompanyUpdateLabel;
    },
    formattedCurrencies() {
      const availableCurrencies = this.bootstrap.currencies.map((currency) => ({
        name: currency,
        disabled: this.companyDetails?.currencies?.includes(currency), // disable option to remove existing currencies
      }));

      return availableCurrencies;
    },
    companyNameRules() {
      return [
        isEntered(this.clonedCompanyDetails.displayName,
          this.translations.companyNameErrorLabel),
        nameLength(this.clonedCompanyDetails.displayName,
          this.translations.nameLengthErrorLabel),
      ];
    },
    partnerSelectRules() {
      return [
        isEntered(this.clonedCompanyDetails.partnerId,
          this.translations.partnerSelectErrorLabel),
      ];
    },
    currenciesRules() {
      return [
        arrayLength(this.translations.currencySelectErrorLabel),
      ];
    },
    jackpotContributionRules() {
      const contribution = this.clonedCompanyDetails.jackpotContribution;
      if (!contribution && !isEqual(contribution, 0)) {
        return [true];
      }
      return [
        isSmaller(2.01, this.translations.jackpotContributionErrorLabel),
        isDecimal(this.translations.decimalsAllowedErrorLabel),
        isLarger(0.09, this.translations.jackpotContributionErrorLabel),
      ];
    },
    jackpotRoundsRules() {
      if (!this.clonedCompanyDetails.jackpotProbability) {
        return [true];
      }
      return [
        isLarger(9999, this.translations.jackpotRoundsErrorLabel),
        noDecimal(this.translations.noDecimalsAllowedErrorLabel),
      ];
    },
    dcRules() {
      return [
        isEntered(this.clonedCompanyDetails.dc,
          this.translations.dcRequiredErrorLabel),
      ];
    },
    sevenWalletDcRules() {
      return [
        isEntered(this.clonedCompanyDetails.meta.sevenWalletDC,
          this.translations.sevenWalletDcRequiredErrorLabel),
      ];
    },
    sevenCompanyIdRules() {
      return [
        isEntered(this.clonedCompanyDetails.meta.sevenCompanyId,
          this.translations.sevenCompanyIdRequiredErrorLabel),
      ];
    },
    isoftbetLicenseeIdRules() {
      return [
        isEntered(this.clonedCompanyDetails.meta.isoftbetLicenseeId,
          this.translations.isoftbetLicenseeIdRequiredErrorLabel),
        isLarger(0, this.translations.isoftbetLicenseeIdNumberErrorLabel),
      ];
    },
    isoftbetWalletUrlRules() {
      return [
        isEntered(this.clonedCompanyDetails.meta.isoftbetWalletUrl,
          this.translations.isoftbetWalletUrlRequiredErrorLabel),
      ];
    },
    dualsoftWalletCodeRules() {
      return [
        arrayLength(this.translations.dualsoftWalletCodeRulesRequiredErrorLabel),
      ];
    },
    dualsoftWalletUrlRules() {
      return [
        isEntered(this.clonedCompanyDetails.meta.dualsoftWalletUrl,
          this.translations.dualsoftWalletUrlRequiredErrorLabel),
      ];
    },
    singularBrandRules() {
      return [
        isEntered(this.clonedCompanyDetails.displayName,
          this.translations.singularBrandErrorLabel),
        nameLength(this.clonedCompanyDetails.displayName,
          this.translations.singularBrandLengthErrorLabel),
      ];
    },
  },
  watch: {
    detailsModalToggler(newValue) {
      this.$refs.form.resetValidation();
      if (!newValue) {
        this.$refs.form.reset();
      }
    },
  },
  created() {
    this.prepareFormForEdit();
  },
};
</script>
